var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return (_vm.content.FieldValues.Parameters.hideForLoggedOut === "true" &&
    _vm.loggedIn) ||
    _vm.content.FieldValues.Parameters.hideForLoggedOut !== "true"
    ? _c("div", { staticClass: "wm-toggle-wrapper" }, [
        _c("div", { staticClass: "wm-toggle" }, [
          _c("input", {
            staticClass: "wm-toggle-checker",
            attrs: { type: "checkbox", id: "pctoggle_chbx_tcs" },
            domProps: {
              checked: _vm.content.FieldValues.Parameters.forceOpen === "true"
            }
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "wm-toggle-label",
              attrs: { for: "pctoggle_chbx_tcs" }
            },
            [
              _vm._v(_vm._s(_vm.content.FieldValues.Title)),
              _c("i", { staticClass: "theme-up" }),
              _c("i", { staticClass: "theme-down" })
            ]
          ),
          _vm._v(" "),
          _c("div", {
            staticClass: "wm-toggle-txt",
            domProps: { innerHTML: _vm._s(_vm.content.FieldValues.Text) }
          })
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68a21a07", { render: render, staticRenderFns: staticRenderFns })
  }
}